import * as React from 'react';
import LottieAnimation from '../assets/Animations/Lottie';
import animationData from '../assets/Animations/lurking-cat';
import CatImageGridComp from './NewContent';



export default class Content extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
        isLoading: true
    };
  }

  componentDidMount(){
    document.getElementById("myBar").style.display = "block";
    document.getElementById("road").style.display = "block";
    setTimeout(() => {
      this.setState({isLoading: false})
    }, 5000);
  }


  render(){
    return (
      this.state.isLoading ? <LottieAnimation lotti={animationData} height={'auto'} width={'40%'} isloop={true}/>
            :
      <div id="catimg">
        <CatImageGridComp genre={this.props.cat} />
      </div>
    );
  }
}



